import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { createUnavailabilityError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  error: createUnavailabilityError,
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: setRequestStateToPending(),
  };
}

function handleSuccess(state: State): State {
  return {
    ...state,
    error: initialState.error,
    request: setRequestStateToSuccess(),
  };
}

function handleFailure(
  state: State,
  data: Boundaries["createUnavailability"]["failure"],
): State {
  return {
    ...state,
    error: data.error,
    request: setRequestStateToFailure(),
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createUnavailabilityRequested]: handleRequest,
    [events.createUnavailabilitySucceeded]: handleSuccess,
    [events.createUnavailabilityFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
